import React from 'react';
import {Create, ReferenceInput, required, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid, schoolYears, TreeCheckboxInput} from '../../components'

export const ClazzSubjectCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <React.Fragment>
          <Grid item xs={12} sm={6} >
            <label>Danh sách lớp *</label>
            <ReferenceInput source="unitIds"
                            reference="units"
                            perPage={999}
                            filter={{clazzWithParents: true, schoolYear: schoolYears[0].id}}
                            {...props} >
              <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
            </ReferenceInput>
          </Grid>
          <Grid item xs={12} sm={6} >
            <label>Danh sách môn học *</label>
            <ReferenceInput source="subjectIds"
                            reference="subjects"
                            perPage={999}
                            validate={required()}
                            {...props} >
              <TreeCheckboxInput optionValue="id" optionText="name" expandTopLevel={true}/>
            </ReferenceInput>
          </Grid>

        </React.Fragment>
      </Grid>
    </SimpleForm>
  </Create>
);

export default ClazzSubjectCreate
